import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { IMAGES } from "@/lib/images";

export default function Properties() {
  const [apps, setApps] = useState(null);

  useEffect(() => {
    api.get("/admin/applications", { params: { status: "SELECTED" } }).then((r) => setApps(r.data.applications));
  }, []);

  return (
    <div data-testid="admin-properties">
      <div className="mb-8">
        <p className="text-[11px] tracking-[0.3em] uppercase text-gold">Public Collection</p>
        <h1 className="mt-3 font-serif font-light text-4xl text-ivory">Selected Properties</h1>
        <p className="mt-3 text-ivory/50 text-sm">Selected properties. Publish or unpublish each to control the public Collection.</p>
      </div>

      {apps === null ? <p className="text-ivory/40">Loading…</p> : apps.length === 0 ? (
        <div className="border border-ivory/10 bg-navy-800 p-16 text-center"><p className="font-serif italic text-2xl text-ivory/60">No selected properties yet.</p></div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="properties-grid">
          {apps.map((a) => (
            <Link key={a.id} to={`/admin/applications/${a.id}`} className="group border border-ivory/10 bg-navy-800 hover:border-gold/30 transition-colors" data-testid={`prop-${a.id}`}>
              <div className="aspect-[4/3] overflow-hidden relative">
                <img src={a.hero_image ? fileUrl(a.hero_image) : (a.images?.[0] ? fileUrl(a.images[0]) : IMAGES.amalfiVilla2)} alt="" className="w-full h-full object-cover" />
                <span className={`absolute top-3 right-3 text-[9px] tracking-widest uppercase px-2 py-1 border backdrop-blur ${a.published ? "border-emerald-400/50 text-emerald-300 bg-navy-900/70" : "border-ivory/30 text-ivory/60 bg-navy-900/70"}`}>{a.published ? "Public" : "Hidden"}</span>
                {a.founding_member && <span className="absolute top-3 left-3 text-[9px] tracking-widest uppercase px-2 py-1 border border-gold/40 text-gold bg-navy-900/70 backdrop-blur">Founding</span>}
              </div>
              <div className="p-5">
                <h3 className="font-serif text-2xl text-ivory group-hover:text-gold transition-colors">{a.property?.name}</h3>
                <p className="text-ivory/45 text-sm mt-1">{[a.property?.city, a.property?.location].filter(Boolean).join(", ")}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
